// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { setupIonicReact } from '@ionic/react'
import '@ionic/react/css/core.css'
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'
import '@ionic/react/css/padding.css'
import '@ionic/react/css/float-elements.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/display.css'
import * as apps from './apps'
import './theme/variables.scss'
import './theme/theme.scss'


setupIonicReact({mode: "md"});


const domainApps: {[key: string]: React.FC<any>} = {
  backoffice: apps.BackofficeApp,
  console: apps.ConsoleApp,
  me: apps.MeApp,
  suppliers: apps.SuppliersApp,
  warehouse: apps.WarehouseApp,
  vision: apps.VisionApp
}


const App: React.FC = () => {
  const appName = window.location.hostname.split('.')[0]
  if (domainApps[appName] === undefined) {
    return null
  }
  const DomainApp: React.FC = domainApps[appName]
  return (<DomainApp/>)
}

export default App
